<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition name="notification-slide">
        <div v-if="$store.state.notification.show" class="max-w-sm w-full bg-white shadow-[0_22px_55px_-26px_rgba(15,23,42,0.55)] rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" v-if="$store.state.notification.success === true" />
                <BanIcon class="h-6 w-6 text-red-400" aria-hidden="true" v-if="$store.state.notification.success === false"/>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">{{$store.state.notification.head}}</p>
                <p class="mt-1 text-sm text-gray-500">{{$store.state.notification.subheader}}</p>
              </div>
              <!-- <div class="ml-4 flex-shrink-0 flex">
                <button @click.prevent="show = false" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9aac53]">
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon,BanIcon } from '@heroicons/vue/outline'
import { XIcon } from '@heroicons/vue/solid'

export default {
  components: {
    CheckCircleIcon,
    BanIcon,
    XIcon,
  },
}
</script>

<style scoped>
.notification-slide-enter-active {
  transition:
    opacity 260ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 420ms cubic-bezier(0.16, 1, 0.3, 1),
    filter 320ms cubic-bezier(0.16, 1, 0.3, 1);
}

.notification-slide-leave-active {
  transition:
    opacity 160ms cubic-bezier(0.7, 0, 0.84, 0),
    transform 240ms cubic-bezier(0.7, 0, 0.84, 0),
    filter 180ms cubic-bezier(0.7, 0, 0.84, 0);
}

.notification-slide-enter-from,
.notification-slide-leave-to {
  opacity: 0;
  transform: translateX(calc(100% + 32px)) scale(0.985);
  filter: blur(1px);
}

.notification-slide-enter-to,
.notification-slide-leave-from {
  opacity: 1;
  transform: translateX(0) scale(1);
  filter: blur(0);
}

@media (prefers-reduced-motion: reduce) {
  .notification-slide-enter-active,
  .notification-slide-leave-active {
    transition: opacity 1ms linear;
  }

  .notification-slide-enter-from,
  .notification-slide-leave-to {
    opacity: 0;
    transform: none;
    filter: none;
  }
}
</style>
